/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
import { navigationBackgroundColor } from '../../common/constants';
var SideNavigation = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      testId = props.testId,
      label = props.label;
  return jsx("nav", {
    ref: ref,
    "data-testid": testId,
    "aria-label": label,
    css: {
      width: '100%',
      height: '100%',
      minWidth: gridSize() * 30,
      backgroundColor: navigationBackgroundColor,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }
  }, children);
});
export default SideNavigation;